import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {AppComponent} from './app.component';
import {DataService} from './services/data.service';
import {GroupListComponent} from './components/groupList/groupList.component';
import {TreeViewComponent} from './components/groupList/treeView.component';
import {StorageService} from './services/storage.service';
import {ResultListComponent} from './components/resultList/resultList.component';
import {ShowAblePipe} from './components/resultList/showAble.pipe';
import {SliderComponent} from './components/slider/slider.component';
import {NouisliderModule} from 'ng2-nouislider';
import {InputFieldComponent} from './components/inputField/inputField.component';
import {CurrencyFormatPipe} from './pipes/CurrencyFormat.pipe';
import {ProductTeaserNamePipe} from './pipes/ProductTeaserName.pipe';
import {DurationUnitPipe} from './pipes/DurationUnit.pipe';
import {DefaultComponent} from './components/default/default.component';
import {AppRoutingModule} from './app-routing.module';
import {AdultLanguageComponent} from './components/adultLanguage/adultLanguage.component';
import {CheckboxComponent} from './components/checkbox/checkbox.component';
import {HighschoolComponent} from './components/highschool/highschool.component';
import {HttpClientModule} from '@angular/common/http';

@NgModule({
    declarations: [
        AppComponent,
        DefaultComponent,
        AdultLanguageComponent,
        HighschoolComponent,
        GroupListComponent,
        TreeViewComponent,
        ResultListComponent,
        ShowAblePipe,
        SliderComponent,
        InputFieldComponent,
        CheckboxComponent,
        CurrencyFormatPipe,
        ProductTeaserNamePipe,
        DurationUnitPipe
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        FormsModule,
        HttpClientModule,
        NouisliderModule
    ],
    providers: [DataService, StorageService],
    bootstrap: [AppComponent]
})
export class AppModule {
}
